// Food photography for each traditional recipe (stock imagery).
// Text content lives in i18n so it can be translated; images stay constant.
export const RECIPE_IMAGES = {
  "cullen-skink":
    "https://images.unsplash.com/photo-1610725663727-08695a1ac3ff?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  "scotch-broth":
    "https://images.unsplash.com/photo-1665593998976-d957f2827fe7?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  haggis:
    "https://images.pexels.com/photos/10289307/pexels-photo-10289307.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "cock-a-leekie":
    "https://images.pexels.com/photos/28913740/pexels-photo-28913740.jpeg?auto=compress&cs=tinysrgb&w=1200",
  stovies:
    "https://images.pexels.com/photos/30635676/pexels-photo-30635676.jpeg?auto=compress&cs=tinysrgb&w=1200",
  cranachan:
    "https://images.unsplash.com/photo-1472555794301-77353b152fb7?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  shortbread:
    "https://images.pexels.com/photos/14757516/pexels-photo-14757516.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "clootie-dumpling":
    "https://images.unsplash.com/photo-1562678280-1280ba8911d0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  "selkirk-bannock":
    "https://images.unsplash.com/photo-1549931319-a545dcf3bc73?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  tablet:
    "https://images.pexels.com/photos/8927931/pexels-photo-8927931.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
